import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { ICandidate } from '@shared/interfaces/candidate.interface';

@Component({
    selector: 'app-sidebar-candidate-about',
    templateUrl: './sidebar.candidate.about.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SidebarCandidateAboutComponent {
  @Input() public candidate: ICandidate;

  constructor() {}
}
